/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-children-prop */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { every, capitalize, sortBy } from 'lodash';
import { Grid, IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormContainer from '../../../FormContainer/FormContainer';
import {
  updateFormWeightState,
  verticalSelect
} from './defaultState/defaultState';
import { handleFormObjectChange } from '../../../Utilities/HandleFormObjectChange';
import { validateForSubmit } from '../../../Utilities/ValidationHelper/ValidateForm';
import { NetworkRequest } from '../../../Utilities/NetworkRequests/NetworkRequests';
import { formatSubmitValues } from '../../../Utilities/SubmitHelper/FormatForSubmit';
import { buildFormFieldsWithStateForm } from '../../../Utilities/formHelper';
import { colors } from '../../../../Utilities/LenoxColors';
import Dialog from '../../../Dialog';
import { variants } from '../../requests';
import LoaderComponent from '../../../Utilities/LoaderComponent';
import { handleChange as updateFilters } from '../../../Filters/actions/actions';

const styles = () => ({
  tableContainer: {
    border: 'solid 1px rgba(20,20,20,.3)',
    borderRadius: '8px',
    margin: '1rem'
  },
  tableTitle: {
    fontSize: '1.25rem',
    textAlign: 'center',
    padding: '.5rem',
    backgroundColor: colors.lenoxDark2,
    color: colors.lenoxLight1,
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    marginBottom: '1rem'
  },
  sectionTitle: {
    fontSize: '1.1rem',
    padding: '.5rem',
    backgroundColor: colors.lenoxDark2,
    color: colors.lenoxLight1,
    margin: '1rem 5rem'
  },
  addForm: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    marginBottom: '-1rem',
    marginTop: '1rem'
  },
  weightedContainer: {
    position: 'relative'
  },
  automaticTestingMessage: {
    padding: '5% 10%',
    textAlign: 'center',
    color: 'rgba(0,0,0,0.54)',
    fontSize: 18
  },
  removeButton: {
    position: 'absolute',
    top: 15,
    left: 15
  }
});

class WeightedForcedForms extends Component {
  constructor(props) {
    super(props);
    const formState = (device) => ({
      ...updateFormWeightState(),
      addWeight: {
        ...updateFormWeightState().addWeight,
        render: () => this.renderAddForm(device)
      }
    });
    this.state = {
      hideForAutomaticTesting: false,
      siteSelect: verticalSelect(),
      baseFormValues: { ...formState() },
      formValues: {
        desktop: [{ ...formState('desktop') }],
        mobile: [{ ...formState('mobile') }]
      },
      open: true,
      submitting: false,
      loading: true,
      variantsByForm: {},
      rawFormData: [],
      dialog: {
        message: '',
        type: 'error',
        title: 'Error'
      },
      confirmationDialog: {
        message: '',
        type: 'confirm',
        title: 'Error'
      },
      confirmationRemoveAllDialog: {
        message: '',
        type: 'confirm',
        title: 'Error'
      }
    };
  }

  componentDidMount() {
    this.loadOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.siteSelect.site.value !== prevState.siteSelect.site.value) {
      this.loadOptions();
    }
  }

  componentWillUnmount() {
    this.handleVerticalChange('site', '2');
  }

  loadOptions = async () => {
    this.setState({ loading: true });
    const { baseFormValues, siteSelect } = this.state;
    const { data } = await variants({
      action: 'getForms',
      vertical: siteSelect.site.value,
      exclude_direct_links: 1
    });
    this.setState({ rawFormData: data });
    if (data && data.length) {
      const mapOptions = (rawOptions) =>
        sortBy(
          rawOptions.map((rawOption) => ({
            value: rawOption,
            display:
              variantsByForm[rawOption] && variantsByForm[rawOption].display
                ? variantsByForm[rawOption].display
                : rawOption
          })),
          'display'
        );
      const variantsByForm = {};
      data.forEach((form) => {
        const excludeWords = (word) =>
          (form.display_name || '').toLowerCase().indexOf(word) === -1;
        if (
          ((form.display_name || '').toLowerCase() === 'compare transunion' ||
            (form.display_name || '').toLowerCase() === 'simple transunion' ||
            excludeWords('transunion')) &&
          excludeWords('remarketing')
        ) {
          variantsByForm[form.merged_form_id] = {
            variant: form.variant_id,
            display: form.display_name
          };
        }
      });
      const newValues = {
        ...baseFormValues,
        form: {
          ...baseFormValues.form,
          options: [
            { value: '0', display: 'Select a Form' },
            ...mapOptions(Object.keys(variantsByForm))
          ]
        }
      };
      this.setState({ baseFormValues: newValues, variantsByForm }, () =>
        this.loadForms()
      );
    } else {
      this.loadForms();
    }
  };

  loadForms = async () => {
    const { baseFormValues, siteSelect } = this.state;
    const { data } = await NetworkRequest(
      'affiliates',
      {
        id: this.props.row
          ? this.props.row.affiliate_id
          : this.props.filters.affiliate_id,
        site_id: siteSelect.site.value
        // test data
        // id: '617',
      },
      'getWeightedForms'
    );

    if (data.automatic_testing) {
      this.setState({ hideForAutomaticTesting: true, loading: false });
      return true;
    }
    this.setState({ hideForAutomaticTesting: false });

    const handleFormData = (formData, device) =>
      formData && formData.length > 0
        ? formData.map((form) => ({
            ...baseFormValues,
            form: {
              ...baseFormValues.form,
              value: +form.merged_form_id
            },
            weight: {
              ...baseFormValues.weight,
              value: form.weight
            },
            addWeight: {
              ...baseFormValues.addWeight,
              render: () => this.renderAddForm(device)
            }
          }))
        : [
            {
              ...baseFormValues,
              form: {
                ...baseFormValues.form
              },
              weight: {
                ...baseFormValues.weight
              },
              addWeight: {
                ...baseFormValues.addWeight,
                render: () => this.renderAddForm(device)
              }
            }
          ];
    this.setState({
      formValues: {
        desktop: handleFormData(data.desktop, 'desktop'),
        mobile: handleFormData(data.mobile, 'mobile')
      },
      loading: false
    });
  };

  handleChange = (device, field, value, i) => {
    const sectionValues = handleFormObjectChange(field, value, {
      ...this.state.formValues[device][i]
    });
    const newFormValues = { ...this.state.formValues };
    newFormValues[device][i] = sectionValues;
    this.setState({ formValues: newFormValues });
  };

  handleVerticalChange = (field, value) => {
    const newValues = handleFormObjectChange(field, value, {
      ...this.state.siteSelect
    });
    this.setState({ siteSelect: newValues }, this.loadOptions);
  };

  toggleDialog = (message = '', type = 'error', title = 'Error') =>
    this.setState({
      dialog: { ...this.state.dialog, message, type, title }
    });

  toggleConfirm = (message = '', type = 'confirm', title = 'Confirm Edit') =>
    this.setState({
      confirmationDialog: {
        ...this.state.confirmationDialog,
        message,
        type,
        title
      }
    });

  toggleRemoveAllConfirm = (
    message = '',
    type = 'confirm',
    title = 'Confirm Remove'
  ) =>
    this.setState({
      confirmationRemoveAllDialog: {
        ...this.state.confirmationRemoveAllDialog,
        message,
        type,
        title
      }
    });

  handleSubmit = () => {
    const validSections = [];
    let errorMessages = [];
    ['desktop', 'mobile'].forEach((device) =>
      this.state.formValues[device].forEach((section) => {
        const { valid, messages } = validateForSubmit(section);
        validSections.push(valid);
        errorMessages = errorMessages.concat(messages);
      })
    );
    if (!every(validSections)) {
      this.toggleDialog(errorMessages, 'error');
      return;
    }
    this.toggleConfirm(
      'Are you sure that you want to change your forced forms?'
    );
  };

  handleReset = () => {
    this.toggleRemoveAllConfirm(
      'Are you sure that you want to remove all your forced forms?'
    );
  };

  handleSubmitRequest = (
    endpoint,
    action,
    formValues,
    callback = null,
    title = 'Forms were successfully saved.'
  ) => {
    const { siteSelect } = this.state;
    this.setState({ submitting: true }, () => {
      const submitFormValues = this.formValues(formValues);
      const params = {
        id: this.props.row
          ? this.props.row.affiliate_id
          : this.props.filters.affiliate_id,
        site_id: siteSelect.site.value,
        forms: submitFormValues,
        action
      };
      this.setState({ submitting: true }, () =>
        NetworkRequest(endpoint, params, action)
          .then(({ data }) => {
            this.handleResponse(data, title);
            callback && callback(data);
          })
          .catch(() => this.setState({ submitting: false }))
      );
    });
  };

  formValues = (formValues) => {
    const submitFormValues = {};
    ['desktop', 'mobile'].forEach((device) => {
      submitFormValues[device] = formValues[device].map((section) => {
        const submitValues = formatSubmitValues(section);
        const filteredRawForm = this.state.rawFormData
          ? this.state.rawFormData.filter(
              (form) => +form.merged_form_id === +submitValues.form
            )
          : [];
        return {
          ...submitValues,
          variant: this.state.variantsByForm[submitValues.form]?.variant,
          form:
            filteredRawForm && filteredRawForm.length > 0
              ? filteredRawForm[0].form_id
              : undefined,
          merged_form_id:
            filteredRawForm && filteredRawForm.length > 0
              ? filteredRawForm[0].merged_form_id
              : undefined
        };
      });
    });
    return submitFormValues;
  };

  handleResponse = (data, title) => {
    this.setState({ submitting: false }, () => {
      this.toggleDialog(
        data.success ? title : data.errors,
        data.success ? 'success' : 'error',
        data.success ? 'Success' : 'Error'
      );
    });
  };

  addWeightedForm = (device) =>
    this.setState(({ formValues, baseFormValues }) => {
      return {
        formValues: {
          ...formValues,
          [device]: [
            ...formValues[device],
            {
              ...baseFormValues,
              form: {
                ...baseFormValues.form
              },
              weight: {
                ...baseFormValues.weight
              },
              addWeight: {
                ...baseFormValues.addWeight,
                render: () => this.renderAddForm(device)
              }
            }
          ]
        }
      };
    });

  removeWeightedForm = (i, device) =>
    this.setState(({ formValues }) => {
      const newWF = { ...formValues };
      newWF[device].splice(i, 1);
      return { formValues: newWF };
    });

  renderConfirmDialog = () => (
    <Dialog
      title={this.state.confirmationDialog.title}
      children={this.state.confirmationDialog.message}
      open={!!this.state.confirmationDialog.message}
      onRequestSave={async () => {
        await this.handleSubmitRequest(
          'affiliates',
          'saveWeightedForms',
          this.state.formValues
        );
        this.toggleConfirm('');
      }}
      onRequestClose={() => setTimeout(() => this.toggleConfirm(), 300)}
      type={this.state.confirmationDialog.type}
      saveButtonText="Submit"
    />
  );

  renderRemoveAllDialog = () => (
    <Dialog
      title={this.state.confirmationRemoveAllDialog.title}
      children={this.state.confirmationRemoveAllDialog.message}
      open={!!this.state.confirmationRemoveAllDialog.message}
      onRequestSave={async () => {
        await this.handleSubmitRequest(
          'affiliates',
          'deleteWeightedForms',
          this.state.formValues,
          this.loadForms,
          'Forms were successfully removed.'
        );
        this.toggleRemoveAllConfirm('');
      }}
      onRequestClose={() =>
        setTimeout(() => this.toggleRemoveAllConfirm(), 300)
      }
      type={this.state.confirmationRemoveAllDialog.type}
      saveButtonText="Submit"
    />
  );

  renderAddForm = (device = 'desktop') => (
    <div className={this.props.classes.addForm}>
      <IconButton onClick={() => this.addWeightedForm(device)} size="large">
        <AddCircle />
      </IconButton>
      Add Weighted Form
    </div>
  );

  renderVerticalSelect = () => (
    <FormContainer
      formValues={buildFormFieldsWithStateForm(
        this.state.siteSelect,
        this.state.siteSelect
      )}
      handleChange={this.handleVerticalChange}
      inputWidth={8}
      separateBlock
    />
  );

  renderDeviceFormContainer = (
    device,
    handleSubmitFunc,
    handleChange,
    submitting,
    dialog,
    handleResetFunc
  ) =>
    this.state.formValues[device].map((section, i) => {
      const isLastForm = this.state.formValues[device].length - 1 === i;
      return (
        <div
          id={`${device}-weighted-form-${i}`}
          className={this.props.classes.weightedContainer}
        >
          {!(i === 0 && this.state.formValues[device].length === 1) && (
            <IconButton
              onClick={() => this.removeWeightedForm(i, device)}
              className={this.props.classes.removeButton}
              size="large"
            >
              <RemoveCircle />
            </IconButton>
          )}
          <FormContainer
            formValues={buildFormFieldsWithStateForm(section, section)}
            submitting={isLastForm ? submitting : null}
            handleChange={(field, value) =>
              handleChange(device, field, value, i)
            }
            handleSubmit={isLastForm ? handleSubmitFunc : null}
            handleReset={handleResetFunc}
            hideReset={device === 'desktop'}
            contentReset="Remove All"
            hideSubmit={device === 'desktop'}
            disabled={this.props.row?.automatic_testing}
            inputWidth={4}
            separateBlock
            dialog={isLastForm ? dialog : null}
            toggleDialog={this.toggleDialog}
            caption="testing"
          />
        </div>
      );
    });

  renderFormContainer = (
    formValues,
    handleSubmitFunc,
    handleChange,
    submitting,
    dialog,
    title,
    handleResetFunc
  ) => (
    <Grid item className={this.props.classes.tableContainer}>
      <div className={this.props.classes.tableTitle}>{title}</div>
      <>
        {this.renderVerticalSelect()}
        {this.state.loading ? (
          <LoaderComponent padding={150} />
        ) : !this.state.hideForAutomaticTesting ? (
          ['desktop', 'mobile'].map((device) => (
            <Grid item>
              <div className={this.props.classes.sectionTitle}>
                {capitalize(device)}
              </div>
              {this.renderDeviceFormContainer(
                device,
                handleSubmitFunc,
                handleChange,
                submitting,
                dialog,
                handleResetFunc
              )}
            </Grid>
          ))
        ) : (
          <div className={this.props.classes.automaticTestingMessage}>
            Automatic Testing is active for this vertical.
            <br />
            <br />
            You cannot use Weighted Forced Forms when Automatic Testing is
            active.
          </div>
        )}
      </>
    </Grid>
  );

  render() {
    const { formValues, submitting, dialog } = this.state;
    return (
      <>
        {this.renderFormContainer(
          formValues,
          this.handleSubmit,
          this.handleChange,
          submitting,
          dialog,
          'Weighted Forced Forms',
          this.handleReset
        )}
        {this.renderConfirmDialog()}
        {this.renderRemoveAllDialog()}
      </>
    );
  }
}

export default connect(
  (state) => ({
    site: state.filters.site,
    automaticTesting: state.automaticTesting.automaticTesting
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateFilters
      },
      dispatch
    )
)(withStyles(WeightedForcedForms, styles));
